import React, { useState, useEffect } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import Sidebar from "../Sidebar/index";
import "./addparts.scss";
import { useNavigate, useLocation } from "react-router-dom";
import PartsAdd from "../../component/PartsAdd/PgmTextField";
import PartsAdd_s from "../../component/PartsAdd_s/PgmTextField";
import { editNewPartAction } from "../../actions/editNewPartAction";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Loader from "../../component/loaderComponent/Loader";
import { safeDecode } from "../../common/decoder";
import { getVehicleAction } from "../../actions/getVehicle";
import { updatepartAction } from "../../actions/partAction";
import { NotificationManager } from "react-notifications";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import PopupConfirmation from "../../component/PopupConfirmation/PopupConfirmation";
import { Modal } from "react-bootstrap";

function EditParts() {
  const { id } = useParams();
  const decodeid = safeDecode(id);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [vehicle, setvehicle] = useState([]);
  const [editLanguage, setEditLanguage] = useState([]);
  const Close = () => {
    navigate("/partslist")
  }
  const location = useLocation();
  const partGroup = location.state?.partGroup;
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");
  const [isLoading, setIsLoading] = useState(false)
  const [discountGroups, setDiscountGroups] = useState([]);
  const [state, setstate] = useState({
    name: "",
    part_id: "",
    price: "",
    attachment: "",
    vehicle: "",
    minimum_order_quantity: "",
    language: "",
    currency: "",
  })

  useEffect(() => {
    editNewPart();
    handleChangeLanguage(language);
    VehicleListData();
  }, []);
  const [confirmationPopupShow, setConfirmationPopupshow] = useState(false);
  const [closePopup, setClosePopup] = useState(false);
  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };
  const item = "Edit"
  const [getVehicleList, setGetVehicleList] = useState([])
  async function VehicleListData() {
    let response = await dispatch(getVehicleAction());
    if (response == 200 || response != null) {
      setGetVehicleList(response.data.data.results);
    }
  }
  const handleSelectLanguage = (event) => {
    setEditLanguage(event.target.value)
  }
  const Country_name = safeDecode(Cookies.get('country_name'));
  const handleChange = (evt) => {
    const { name, id, value } = evt.target;
    setstate({
      ...state,
      [id]: value.replace(/^ +/gm, ""),
    });
  };

  async function editNewPart() {
    setIsLoading(true)
    let response = await dispatch(editNewPartAction(decodeid));
    if (response == 200 || response != null) {
      setvehicle(response.data?.data?.vehicle.map(({ vehicle_id, ...item }) => ({ id: vehicle_id, ...item })));
      setEditLanguage(response.data?.data?.language)
      setstate({
        name: response.data.data.name,
        part_id: response.data.data.part_number,
        price: response.data.data.price,
        attachment: response.data.data.attachment,
        minimum_order_quantity: response.data.data.minimum_order_quantity,
        currency: response.data.data.currency
      })
      setDiscountGroups(response?.data?.data?.discount_groups || []);
      setIsLoading(false)
    }
  }

  const handlePriceChange = (event) => {
    let newVal = event.target.value.replace(/[^\d.]/g, '');

    // Determine the price based on the edit mode
    const editedPrice = item === 'Edit' ? state.price : '';

    // Format the numeric value with the currency symbol
    let formattedValue = newVal.length > 0 ? `${newVal}` : editedPrice;

    setstate({
      ...state,
      price: newVal
    });

    // // Set the cursor position after the currency symbol
    // setTimeout(() => {
    //   const input = document.getElementById('price');
    //   const strLength = state.currency.length + newVal.length; // Adjusted caret position
    //   input.focus();
    //   input.setSelectionRange(strLength, strLength);
    // }, 100);
  };

  const handleChangedropdown = (event) => {
    const selectedValue = event.target.value;
    let finalArr = []
    if (selectedValue.length === 1) {
      setvehicle(selectedValue)
    } else
      if (selectedValue.length > 1) {
        selectedValue.map((data) => {
          if (selectedValue.filter((item) => data.id === item.id).length == 2) {
            setvehicle(finalArr)
          }
          else if (selectedValue.filter((item) => data.id === item.id).length == selectedValue.length) {
            setvehicle([]);
          }
          else {
            finalArr.push(data)
            setvehicle(finalArr)
          }
        })
      } else {
        setvehicle([])
      }
  }

  const onupdatepart = async () => {
    setIsLoading(true);
    var formData = new FormData();
    formData.append("name", state.name);
    formData.append("part_number", state.part_id);
    formData.append("price", state.price);
    formData.append("minimum_order_quantity", state.minimum_order_quantity);
    { vehicle.map((data) => formData.append("vehicle_ids", data.id)) }
    {editLanguage && formData.append("language", editLanguage)};
    formData.append("discount_groups", JSON.stringify(discountGroups));
    let response = await dispatch(updatepartAction(formData, decodeid));
    if (response?.status == 200) {
      setIsLoading(false);
      NotificationManager.success(response.data.message);
      navigate("/partslist")
      window.scroll(0, 0);
    } else if (response?.status == 400) {
      setIsLoading(false)
      setConfirmationPopupshow(false)
    }
  };

  const handleConfirmationPopup = () => {
    setConfirmationPopupshow(true);
  };
  const handleConfirmationPopupClose = () => {
    setConfirmationPopupshow(false);
  };

  return (
    <div className="partlist_containers">
      <div className="addparts_container">
        <div className="Addpartsmain">
          <div className="header_border">
            <p className="pgm-list-header-text">TVS &gt; {t('editparts.editpart')}</p>
          </div>
          <div className="AddPartsontainers">
            <div className="Edit_new_part_text">
              <span>{t('editparts.editnewpart')}</span>
              <button onClick={() => setClosePopup(true)}>{t('addparts.close')}</button>
            </div>
            {isLoading ? (<Loader />) : (
              <div>
                <div>
                  <PartsAdd state={state} mode={item} Country_name={Country_name} handleChange={handleChange} handlePriceChange={handlePriceChange} />
                </div>
                <div>
                  <PartsAdd_s
                    setvehicle={setvehicle}
                    Country_name={Country_name}
                    handleConfirmationPopup={handleConfirmationPopup}
                    state={state}
                    vehicle={vehicle}
                    mode={item}
                    AllVehicleList={getVehicleList}
                    handleChange={handleChange}
                    onupdatepart={onupdatepart}
                    handleSelectLanguage={handleSelectLanguage}
                    editLanguage={editLanguage}
                    handleChangedropdown={handleChangedropdown}
                    meta={partGroup}
                    discountGroups={discountGroups}
                    setDiscountGroups={setDiscountGroups}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="footer_div">
            <Footer />
          </div>
        </div>
      </div>
      <Modal
        className="expertise-modal"
        show={confirmationPopupShow}
        onHide={handleConfirmationPopupClose}
      >
        <Modal.Body>
          {confirmationPopupShow && (
            <PopupConfirmation
              handleConfirmationPopupClose={handleConfirmationPopupClose}
              onSaveClick={onupdatepart}
              loader={isLoading}
            />
          )}
        </Modal.Body>
      </Modal>
      <Modal
        className="expertise-modal"
        show={closePopup}
        onHide={() => setClosePopup(false)}
      >
        <Modal.Body>
          {closePopup && (
            <PopupConfirmation
              handleConfirmationPopupClose={Close}
              onSaveClick={onupdatepart}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default EditParts;
